export default "__VITE_ASSET__d9755373__"